export const environment = {
    production: false,
    API_BASE_URL: '/api',
    CHECKOUT_BASE_URL: 'https://checkout.flowpay.it'
};
